module.exports = __webpack_public_path__ + "img/mobile-differ.6416016f.png";